export const alertTemplate = {
  id: 523,
  versionId: '2077ee3f5d520a2d3d8b0295dedb689601dba9cd',
  document: {
    rootNodeId: '1kPyxV',
    nodes: {
      DBNxk: {
        type: 'Typography',
        data: { custom: { variant: 'P' } },
        css: {
          marginTop: '0',
          textAlign: 'left',
          marginLeft: '0',
          paddingTop: 8,
          marginRight: '0',
          paddingLeft: 16,
          marginBottom: '0',
          paddingRight: 24,
          paddingBottom: 8,
        },
        nodes: ['1VE6rm'],
      },
      fgp7H: {
        type: 'Typography',
        data: { custom: { variant: 'P' } },
        css: {
          marginTop: '0',
          textAlign: 'left',
          marginLeft: '0',
          paddingTop: 8,
          marginRight: '0',
          paddingLeft: 16,
          marginBottom: '0',
          paddingRight: 24,
          paddingBottom: 8,
        },
        nodes: ['1yaqyO'],
      },
      '3bJZbD': {
        type: 'Card',
        props: { variant: 'wckiqw', isDismissible: true },
        css: {
          display: 'flex',
          alignSelf: 'flex-start',
          marginTop: 8,
          alignItems: 'center',
          flexShrink: 1,
          marginLeft: 8,
          paddingTop: '0',
          marginRight: 8,
          paddingLeft: '0',
          marginBottom: 8,
          paddingRight: 24,
          flexDirection: 'row',
          paddingBottom: '0',
          justifyContent: 'flex-start',
        },
        nodes: ['15pg7t', '4htJqr'],
        states: { cHCsLF4pYEZUFHfDXaH0J: {} },
      },
      '1E3vmz': {
        type: 'Image',
        props: { src: 'https://media.candulabs.com/1/select-icon-info.svg', height: '30px' },
        css: {
          maxWidth: 'none',
          marginTop: 8,
          maxHeight: 'none',
          marginLeft: 8,
          marginRight: 8,
          marginBottom: 8,
        },
      },
      '4htJqr': { type: 'RichText', nodes: ['fkXYC'] },
      '2XhZR': {
        type: 'Typography',
        data: { custom: { variant: 'P' } },
        css: {
          marginTop: '0',
          textAlign: 'left',
          marginLeft: '0',
          paddingTop: 8,
          marginRight: '0',
          paddingLeft: 16,
          marginBottom: '0',
          paddingRight: 24,
          paddingBottom: 8,
        },
        nodes: ['4v0BV8'],
      },
      '15pg7t': {
        type: 'View',
        css: {
          width: '46px',
          display: 'flex',
          flexGrow: 1,
          alignSelf: 'stretch',
          alignItems: 'center',
          paddingTop: '0',
          paddingLeft: '0',
          paddingRight: '0',
          flexDirection: 'column',
          paddingBottom: '0',
          justifyContent: 'center',
          backgroundColor: '#59c3c3',
        },
        nodes: ['2XFNGw'],
      },
      '1hPic7': {
        type: 'View',
        css: {
          width: '46px',
          display: 'flex',
          flexGrow: 1,
          alignSelf: 'stretch',
          alignItems: 'center',
          paddingTop: '0',
          paddingLeft: '0',
          paddingRight: '0',
          flexDirection: 'column',
          paddingBottom: '0',
          justifyContent: 'center',
          backgroundColor: '#4392f1',
        },
        nodes: ['1E3vmz'],
      },
      '1VE6rm': {
        type: 'Text',
        props: { children: 'Add an information alert with further details.' },
      },
      '39uDBY': {
        type: 'Image',
        props: { src: 'https://media.candulabs.com/1/danger.svg', height: '30px' },
        css: {
          maxWidth: 'none',
          marginTop: 8,
          maxHeight: 'none',
          marginLeft: 8,
          marginRight: 8,
          marginBottom: 8,
        },
      },
      GSCp0: {
        type: 'View',
        css: {
          width: '46px',
          display: 'flex',
          flexGrow: 1,
          alignSelf: 'stretch',
          alignItems: 'center',
          paddingTop: '0',
          paddingLeft: '0',
          paddingRight: '0',
          flexDirection: 'column',
          paddingBottom: '0',
          justifyContent: 'center',
          backgroundColor: '#ee4266',
        },
        nodes: ['4x7Phl'],
      },
      '4x7Phl': {
        type: 'Image',
        props: { src: 'https://media.candulabs.com/1/callouticon.svg', height: '30px' },
        css: {
          maxWidth: 'none',
          marginTop: 8,
          maxHeight: 'none',
          marginLeft: 8,
          marginRight: 8,
          marginBottom: 8,
        },
      },
      '3DRsjy': {
        type: 'Card',
        props: { variant: 'wckiqw', isDismissible: true },
        css: {
          display: 'flex',
          alignSelf: 'flex-start',
          marginTop: 8,
          alignItems: 'center',
          flexShrink: 1,
          marginLeft: 8,
          paddingTop: '0',
          marginRight: 8,
          paddingLeft: '0',
          marginBottom: 8,
          paddingRight: 24,
          flexDirection: 'row',
          paddingBottom: '0',
          justifyContent: 'flex-start',
        },
        nodes: ['GSCp0', '2THAqc'],
        states: { dIXsUZPRLZ5h4O_XtI9DT: {} },
      },
      '3KUV2l': { type: 'RichText', nodes: ['DBNxk'] },
      '1yaqyO': {
        type: 'Text',
        props: { children: 'Add a warning alert with a clear explanation.' },
      },
      '2YcDh': {
        type: 'Card',
        props: { variant: 'wckiqw', isDismissible: true },
        css: {
          display: 'flex',
          alignSelf: 'flex-start',
          marginTop: 8,
          alignItems: 'center',
          flexShrink: 1,
          marginLeft: 8,
          paddingTop: '0',
          marginRight: 8,
          paddingLeft: '0',
          marginBottom: 8,
          paddingRight: 24,
          flexDirection: 'row',
          paddingBottom: '0',
          justifyContent: 'flex-start',
        },
        nodes: ['3PWNFT', '37VbWH'],
        states: { aYeRaCzBMsCwuL4MRphGg: {} },
      },
      '37VbWH': { type: 'RichText', nodes: ['fgp7H'] },
      '4v0BV8': {
        type: 'Text',
        props: { children: 'Add a danger alert. This indicates the action cannot be completed.' },
      },
      '2THAqc': { type: 'RichText', nodes: ['2XhZR'] },
      '2XFNGw': {
        type: 'Image',
        props: { src: 'https://media.candulabs.com/1/whitetick.svg', height: '30px' },
        css: {
          maxWidth: 'none',
          marginTop: 8,
          maxHeight: 'none',
          marginLeft: 8,
          marginRight: 8,
          marginBottom: 8,
        },
      },
      fkXYC: {
        type: 'Typography',
        data: { custom: { variant: 'P' } },
        css: {
          marginTop: '0',
          textAlign: 'left',
          marginLeft: '0',
          paddingTop: 8,
          marginRight: '0',
          paddingLeft: 16,
          marginBottom: '0',
          paddingRight: 24,
          paddingBottom: 8,
        },
        nodes: ['2pUO9c'],
      },
      '2pUO9c': {
        type: 'Text',
        props: { children: 'Add a success alert with a clear explanation.' },
      },
      '43cQ5N': {
        type: 'Card',
        props: { variant: 'wckiqw', isDismissible: true },
        css: {
          display: 'flex',
          alignSelf: 'flex-start',
          marginTop: 8,
          alignItems: 'center',
          flexShrink: 1,
          marginLeft: 8,
          paddingTop: '0',
          marginRight: 8,
          paddingLeft: '0',
          marginBottom: 8,
          paddingRight: 24,
          flexDirection: 'row',
          paddingBottom: '0',
          justifyContent: 'flex-start',
        },
        nodes: ['1hPic7', '3KUV2l'],
        states: { ngeChoT3fxcpT0aqPD69i: {} },
      },
      '1kPyxV': {
        type: 'Document',
        css: {
          display: 'flex',
          alignItems: 'stretch',
          paddingTop: '0',
          paddingLeft: '0',
          paddingRight: '0',
          flexDirection: 'column',
          paddingBottom: '0',
          justifyContent: 'flex-start',
        },
        nodes: ['43cQ5N', '3bJZbD', '2YcDh', '3DRsjy'],
      },
      '3PWNFT': {
        type: 'View',
        css: {
          width: '46px',
          display: 'flex',
          flexGrow: 1,
          alignSelf: 'stretch',
          alignItems: 'center',
          paddingTop: '0',
          paddingLeft: '0',
          paddingRight: '0',
          flexDirection: 'column',
          paddingBottom: '0',
          justifyContent: 'center',
          backgroundColor: '#FBC857',
        },
        nodes: ['39uDBY'],
      },
    },
    stateProviders: {
      aYeRaCzBMsCwuL4MRphGg: { resolver: { type: 'CardApi' } },
      cHCsLF4pYEZUFHfDXaH0J: { resolver: { type: 'CardApi' } },
      dIXsUZPRLZ5h4O_XtI9DT: { resolver: { type: 'CardApi' } },
      ngeChoT3fxcpT0aqPD69i: { resolver: { type: 'CardApi' } },
    },
  },
};
